import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UserTableContainer from '../containers/user-table.container';
import UserDetailsContainer from '../containers/user-details.container';
import UserCreateContainer from '../containers/user-create.container';
import UserUpdateContainer from '../containers/user-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';
import TenantGuard from '@components/common/TenantGuard';

// Helper function to add default query parameters to the user list page
const UserListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <UserTableContainer />;
};

export const userRoutes = [
  {
    path: 'user',
    element: (
      <TenantGuard showHeader={true} headerTitle="User List" showBreadcrumbs={true}>
        <UserListWithParams />
      </TenantGuard>
    ),
  },
  {
    path: 'user/create',
    element: (
      <TenantGuard showHeader={true} headerTitle="Create User" showBreadcrumbs={true}>
        <UserCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'user/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="User Details" showBreadcrumbs={true}>
        <UserDetailsContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'user/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update User" showBreadcrumbs={true}>
        <UserUpdateContainer />
      </TenantGuard>
    ),
  },
];

export default userRoutes;
